import { State } from "@progress/kendo-data-query";
import { GridFlavorEnum, GridFlavorModifiersEnum } from '../../enums/grid.enums';
import { ColumnTotals } from "../../interfaces/kendo-grid-data-result.interface";
export class GridParams {
    public kendoGridState: State;
    public gridFlavor: GridFlavorEnum;
    public gridFlavorModifier: GridFlavorModifiersEnum;
    public columnTotals: ColumnTotals;

    constructor(kendoGridState: State, gridFlavor: GridFlavorEnum, gridFlavorModifier: GridFlavorModifiersEnum, columnTotals: ColumnTotals) {
        this.kendoGridState = kendoGridState;
        this.gridFlavor = gridFlavor;
        this.gridFlavorModifier = gridFlavorModifier;
        this.columnTotals = columnTotals;
    }
}
